import classNames from 'classnames';
import { useRouter } from 'next/router';
import { FC, ReactNode, useEffect, useState } from 'react';
import Accordion from '~/components/Accordion';
import FAQ from '~/components/FAQ';
// import ProductShippingTwo from "~/components/ProductShippingTwo";
import styles from './ProductDetailMoreInfo.module.scss';
import ProductDescription from './tabs/ProductDescription';
import dynamic from 'next/dynamic';
import { useQuery } from '@apollo/client';
import { QUERY_GET_CMS_BLOCKS } from '~/data/home';
import { Identifiers } from '~/constants/enum';
import { Product, ProductVariant } from '~/services/product';
import { isEmpty } from 'lodash';
import BlockContent from '~/components/BlockContent';

const ProductShippingTwo = dynamic(() => import('~/components/ProductShippingTwo'), {
    ssr: false,
    loading(loadingProps) {
        return <div>Loading...</div>;
    }
});

const detaulTabs: TabItems[] = [
    {
        key: 'description',
        title: 'Item details',
        children: (props) => (
            <div className="flex flex-col">
                <ProductDescription {...props} />
            </div>
        )
    },
    {
        key: 'shipping',
        title: 'Shipping and Refund',
        children: (props) => (
            <div>
                <ProductShippingTwo {...props} />
            </div>
        )
    },
    {
        key: 'qanda',
        title: 'FAQs',
        children: (props) => (
            <div className="!text-[16px]">
                <FAQ {...props} />
            </div>
        )
    },
    {
        key: 'qanda2',
        title: 'Return And Refund Policy',
        children: (
            <div className="!text-[16px]">
                <BlockContent indentifiers={['return-and-refund-policy-product']} />
            </div>
        )
    }
    // {
    // key: "qanda",
    //title: "FAQs",
    //children: (
    //<div className="!text-[16px]">
    //    <FAQ />
    //   </div>
    // ),
    // },
];

interface TabItems {
    key: string;
    title: string;
    children?: ReactNode | ((props: any) => ReactNode);
}

interface ProductDetailTabsProps {
    items?: TabItems[];
    product: Product;
    variant: ProductVariant;
}

const ProductDetailMoreInfo: FC<ProductDetailTabsProps> = ({ items = detaulTabs, product, variant }) => {
    const router = useRouter();

    const productSlug = router.query.slug;
    const tab = router.query.tab;
    const [activeTab, setActiveTab] = useState(items[0]?.key);

    useEffect(() => {
        setActiveTab(items[0]?.key);
    }, [productSlug]);

    useEffect(() => {
        const foundTab = items.find((i) => i.key === tab);
        if (foundTab) {
            setActiveTab(foundTab.key);
        }
    }, [tab]);

    if (isEmpty(product)) return null;

    return (
        <div id="product-detail-tabs" className={classNames('lg:pt-5 ', styles.product_detail_tabs)}>
            {!!items.length ? (
                <Accordion
                    className="flex flex-col flex-1  "
                    items={items.map((item) => ({
                        label: item.title,
                        key: item.key,
                        content:
                            typeof item.children === 'function'
                                ? item.children({ activeTab, product, variant })
                                : item.children
                    }))}
                    defaultActive={['description']}
                />
            ) : null}
        </div>
    );
};

export default ProductDetailMoreInfo;
